import { Box } from "@mui/material";
import React from "react";
import NewPrinter from "./Components/NewPrinter";
import NewPrinterTable from "./Components/NewPrinterTable";
import { useStyles } from "../../theme/styles";

const Category: React.FC = () => {
  const classes = useStyles();

  return (
    <Box sx={{ p: 2 }} className={classes.indexBox}>
      <NewPrinter />
      <Box sx={{ height: "75px" }} />
      <NewPrinterTable />
    </Box>
  );
};

export default Category;
